import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';

const DashboardService = Services.dashboard;
const DashboardTypes = VuexTypes.dashboard;
export default {
  [DashboardTypes.DASHBOARD_STRUCTURES_DATA]: ({ commit, state }) => {
    state.dashboardStructuresData['status'] = statuses.LOADING;
    DashboardService.structuresList().then((data) => {
      commit(DashboardTypes.DASHBOARD_STRUCTURES_DATA, data);
    }).catch((errResponse) => {
      commit(DashboardTypes.DASHBOARD_STRUCTURES_DATA, errResponse);
    });
  },
};
